<div class="selector-col" *ngIf="referenceDataLoaded; else loading">

  <!-- Date range, time zone, reading source -->
  <div class="date-panel">
    <div class="list-panel-header">
      <label>Date Range</label>
      <label class="list-panel-count">{{ selectedDateRangeName }}</label>
    </div>

    <div class="date-panel-body">
      <div class="quick-ranges">
        <button type="button" class="btn btn-sm quick-range-btn" (click)="datesUpdated('Last 4 hrs')">Last 4 hrs</button>
        <button type="button" class="btn btn-sm quick-range-btn" (click)="datesUpdated('Last 8 hrs')">Last 8 hrs</button>
        <button type="button" class="btn btn-sm quick-range-btn" (click)="datesUpdated('Last 12 hrs')">Last 12 hrs</button>
        <button type="button" class="btn btn-sm quick-range-btn" (click)="datesUpdated('Last 24 hrs')">Last 24 hrs</button>
      </div>

      <input type="text" name="selectorDaterange" class="daterangeinput" autocomplete="off"
             ngxDaterangepickerMd
             [(ngModel)]="selectedDateRange"
             [showCustomRangeLabel]="true"
             [alwaysShowCalendars]="true"
             [ranges]="ranges"
             [showRangeLabelOnInput]="true"
             [linkedCalendars]="true"
             [showClearButton]="false"
             (datesUpdated)="datesUpdated('')"
             (rangeClicked)="setRangeSelected($event)"
             placeholder="Select Date Range" />

      <div class="field-block">
        <label class="field-label">Displayed Timezone</label>
        <div class="radio-inline">
          <label><input type="radio" [(ngModel)]="selectedTimeZone" name="selectorTz" value="Local" (ngModelChange)="selectedTimeZoneChanged()" /> Local</label>
          <label><input type="radio" [(ngModel)]="selectedTimeZone" name="selectorTz" value="Source" (ngModelChange)="selectedTimeZoneChanged()" /> Source</label>
          <label><input type="radio" [(ngModel)]="selectedTimeZone" name="selectorTz" value="UTC" (ngModelChange)="selectedTimeZoneChanged()" /> UTC (GMT+0)</label>
        </div>
      </div>

      <div class="field-block" *ngIf="showReadingSourceOptions">
        <label class="field-label">Readings</label>
        <div class="radio-inline">
          <label><input type="checkbox" [(ngModel)]="showOriginalReadings" name="selectorOrig" (ngModelChange)="selectedReadingSourceChanged()" /> Original Values</label>
          <label><input type="checkbox" [(ngModel)]="showCalibratedReadings" name="selectorCal" (ngModelChange)="selectedReadingSourceChanged()" /> Calibrated Values</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Sensors and Groups -->
  <div #sensorsPanel class="grow-panel list-panel" [style.max-height.px]="sensorsPanelMaxHeightPx">
    <div class="list-panel-header">
      <label>Sensors and Groups</label>
      <label class="list-panel-count">Selected Sensors: {{ selectedSensors.length }}</label>
    </div>

    <div class="list-panel-body">
      <div class="list-search-row">
        <div class="select-all-toggle" (click)="toggleCheckedSensors()" title="Select / clear all">▣</div>
        <i class="fa fa-search list-search-icon" (click)="sensorSearchTextChanged()"></i>
        <form (ngSubmit)="sensorSearchTextChanged()">
          <input [(ngModel)]="searchSensorsText" placeholder="Search" type="text" name="searchSensorsText" autocomplete="off" class="list-search-input" />
        </form>
      </div>

      <p-table [columns]="SensorsAndGroupsCols" [value]="sensorsAndGroupsDisplayed" [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="i">
          <tr class="list-row">
            <td [ngStyle]="{'width': columns[0].width}" class="list-cell">
              <!-- A group uses a native checkbox so it can show the indeterminate (partial) state -->
              <input *ngIf="rowData.isSensorGroup" type="checkbox" name="grp{{i}}" [(ngModel)]="rowData.checked" [ngModelOptions]="{standalone: true}"
                     [indeterminate]="rowData.indeterminate" (ngModelChange)="onGroupChecked(rowData)" style="cursor: pointer;" />
              <p-checkbox *ngIf="rowData.isSensor" id="{{i}}" name="{{i}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="sensorSelectionChanged()"></p-checkbox>
            </td>
            <td [ngStyle]="{'width': columns[1].width}" class="list-cell">
              <div *ngIf="rowData.isSensorGroup" class="group-label" (click)="toggleGroupExpanded(rowData)">
                <i class="fa" [ngClass]="rowData.expanded ? 'fa-chevron-down' : 'fa-chevron-right'" style="margin-right: 6px;"></i>
                <i class="fa fa-folder" style="margin-right: 5px;"></i>
                {{ rowData.name }} ({{ groupCheckedCount(rowData) }}/{{ rowData.count }})
              </div>
              <div *ngIf="rowData.isSensor" class="sensor-label">{{ rowData.name }}</div>
            </td>
          </tr>

          <!-- Expanded group: one indented row per member sensor -->
          <ng-container *ngIf="rowData.isSensorGroup && rowData.expanded">
            <tr *ngFor="let child of rowData.children" class="list-row">
              <td [ngStyle]="{'width': columns[0].width}" class="list-cell">
                <p-checkbox name="grp{{i}}child{{child.id}}" [(ngModel)]="child.checked" [ngModelOptions]="{standalone: true}" binary="true" (ngModelChange)="onGroupChildChecked(rowData)"></p-checkbox>
              </td>
              <td [ngStyle]="{'width': columns[1].width}" class="list-cell child-cell">{{ child.name }}</td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>

    <!-- Drag handle: slide up/down to resize the Sensors and Groups panel. -->
    <div class="resize-grip" (mousedown)="startSensorsResize($event)" title="Drag to resize">
      <div class="resize-grip-bar"></div>
    </div>
  </div>

  <!-- Reading Types -->
  <div *ngIf="selectedSensors.length > 0" class="grow-panel list-panel" [style.max-height.px]="readingTypesPanelMaxHeightPx">
    <div class="list-panel-header">
      <label>Reading Types</label>
      <span class="list-panel-count">
        Selected Types: {{ selectedReadingTypes.length }}
        <i class="fas fa-sync-alt refresh-icon" (click)="refreshRequested.emit()" title="Reload the readings for the selected reading types"></i>
      </span>
    </div>

    <div class="list-panel-body">
      <div class="list-search-row">
        <div class="select-all-toggle" (click)="toggleCheckedReadings()" title="Select / clear all">▣</div>
        <i class="fa fa-search list-search-icon" (click)="readingTypeSearchTextChanged()"></i>
        <form (ngSubmit)="readingTypeSearchTextChanged()">
          <input [(ngModel)]="searchReadingTypeText" placeholder="Search" type="text" name="searchReadingTypeText" autocomplete="off" class="list-search-input" />
        </form>
      </div>

      <p-table [columns]="SensorReadingTypesCols" [value]="readingTypesDisplayed" [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="i">
          <tr class="list-row">
            <td [ngStyle]="{'width': columns[0].width}" class="list-cell">
              <p-checkbox id="{{i}}" name="{{i}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="readingTypeSelectionChanged()"></p-checkbox>
            </td>
            <td [ngStyle]="{'width': columns[1].width}" class="list-cell">{{ rowData.type }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="selector-loading">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    <span>Loading...</span>
  </div>
</ng-template>
